export const MIN_INTERIVEW_TIME_SLOTS = 2;

export const INITIAL_INTERVIEW_TIME_SLOTS = new Array(MIN_INTERIVEW_TIME_SLOTS).fill({ date: null, time: null });
